"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetDataParametersFromJSON = WidgetDataParametersFromJSON;
exports.WidgetDataParametersFromJSONTyped = WidgetDataParametersFromJSONTyped;
exports.WidgetDataParametersToJSON = WidgetDataParametersToJSON;
exports.WidgetDataParametersToJSONTyped = WidgetDataParametersToJSONTyped;
const runtime_1 = require("../runtime");
function WidgetDataParametersFromJSON(json) {
    return WidgetDataParametersFromJSONTyped(json, false);
}
function WidgetDataParametersFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...json,
        'contentId': !(0, runtime_1.exists)(json, 'contentId') ? undefined : json['contentId'],
        'imgIndex': !(0, runtime_1.exists)(json, 'imgIndex') ? undefined : json['imgIndex'],
    };
}
function WidgetDataParametersToJSON(value) {
    return WidgetDataParametersToJSONTyped(value, false);
}
function WidgetDataParametersToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...value,
        'contentId': value.contentId,
        'imgIndex': value.imgIndex,
    };
}
